import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getSearchModeLabel, getSearchModeSubtitle, SearchModeStrings, } from '#pplx/frontend/apps/ask/search-modes/core/search-modes-names.js';
import { isSearchMode, SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
import { modelsClient } from '#pplx_generated/typespec/rest/models/client.js';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
const queryKey = QueryClientHelper.makeQueryKey('/rest/models/modes');
const getFallbackSearchModes = ({ $t }) => {
    return Object.entries(SearchModeStrings)
        .map(([id, mode]) => {
        if (!isSearchMode(id)) {
            return null;
        }
        const subtitleDescriptor = getSearchModeSubtitle(id);
        const subtitle = subtitleDescriptor ? $t(subtitleDescriptor) : undefined;
        if (id === SearchMode.AGENTIC_RESEARCH) {
            return {
                id,
                label: $t(getSearchModeLabel(id)),
                description: $t(mode.description),
                subtitle,
                subscriptionTier: 'max',
            };
        }
        return {
            id,
            label: $t(getSearchModeLabel(id)),
            description: $t(mode.description),
            subtitle,
        };
    })
        .filter((mode) => mode !== null);
};
const mapSchemaApiSearchMode = (mode) => {
    if (!isSearchMode(mode.id)) {
        return null;
    }
    return {
        id: mode.id,
        label: mode.label,
        description: mode.description,
        badge: mode.badge ?? undefined,
        subtitle: mode.subtitle ?? undefined,
        subscriptionTier: mode.subscriptionTier ?? undefined,
    };
};
const mapSchemaApiSearchModes = (modes) => {
    return modes.map(mapSchemaApiSearchMode).filter((mode) => mode !== null);
};
export const useApiSearchModes = ({ reason, enabled = true, }) => {
    const intl = useIntl();
    const query = useQuery({
        queryFn: async () => {
            const { error, data, response } = await modelsClient.GET('/rest/models/modes', reason);
            if (error) {
                throw new ApiClientsError('API_CLIENTS_ERROR', {
                    cause: error,
                    status: response.status ?? 0,
                });
            }
            return mapSchemaApiSearchModes(data.modes);
        },
        queryKey,
        enabled,
    });
    return useMemo(() => ({
        modes: query.data ?? getFallbackSearchModes(intl),
    }), [query.data, intl]);
};
//# sourceMappingURL=useApiSearchModes.js.map